import clsx from 'clsx'

import { RadioItem } from 'shared/ui/RadioGroup'
import type { RadioItemProps } from 'shared/ui/RadioGroup/RadioItem'
import { Tooltip } from 'shared/ui/Tooltip'

import styles from './CartDeliverySlot.module.scss'

interface CartDeliverySlotProps {
  label: string
  value: string
  isFreeForCart?: boolean
  disabled?: boolean
}

const CartDeliverySlot = ({
  label,
  value,
  isFreeForCart,
  disabled
}: CartDeliverySlotProps) => {
  if (disabled) {
    return (
      <Tooltip
        id='cart-delivery-slot-tooltip-disabled'
        title='Brak wolnych miejsc w tym terminie'
        placement='top-left'
      >
        <SlotItem
          value={value}
          $isFreeForCart={isFreeForCart}
          disabled={disabled}
        >
          {label}
        </SlotItem>
      </Tooltip>
    )
  }

  return (
    <SlotItem value={value} $isFreeForCart={isFreeForCart}>
      {label}
    </SlotItem>
  )
}

export default CartDeliverySlot

const SlotItem = ({
  $isFreeForCart,
  className,
  ...props
}: RadioItemProps & { $isFreeForCart?: boolean }) => (
  <RadioItem
    className={clsx(
      styles.slotItem,
      { [styles.slotItemFreeForCart]: $isFreeForCart },
      className
    )}
    {...props}
  />
)
